module.exports = " <a class=link-btn _v-5108d868=\"\"> <slot _v-5108d868=\"\"></slot> </a> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-5108d868!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LinkBtn.vue
// module id = 323
// module chunks = 2